/**
 * WixMart — вагові товари з ТОЧНОЮ вагою шматка (мітка товару `wxm-waga-dokladna`).
 * План: projects/wixmart-office/weighted-pieces-plan.md (vault), сервер: /api/weighted/public/*.
 *
 * Що робить цей скрипт:
 *  1. Картка товару: підсвічує плашки ваг за живим станом сервера (вільно / у кошику
 *     іншого клієнта / вже нема), а при «Dodaj do koszyka» СПЕРШУ бронює шматок на
 *     сервері і лише потім пускає рідне додавання Dawn — з прихованою властивістю
 *     рядка `_wxm_hold` (номер броні). 409 = шматок зайнятий → напис і оновлення плашок.
 *  2. Кошик і шухляда: при відкритті перевіряє кожен ваговий рядок на сервері.
 *     Бронь чинна → «Zarezerwowane do HH:MM»; була знята, а вага вільна → поновлена
 *     тим самим номером; вільної нема → рядок червоний з причиною і вибором іншої ваги
 *     («Zamień») або «Usuń». Кнопка «Оформити» не пускає, поки є червоні рядки, а
 *     перед переходом до оплати подовжує бронь (extend=checkout).
 *
 * ⛔ Правила безпеки: сервер недоступний → НЕ блокуємо покупця (кошик і оформлення
 * працюють як звичайно, бронь довизначиться на сервері за номером замовлення).
 * Блокуємо лише за ЧІТКОЮ відповіддю сервера (409 «зайнято», «продано»).
 *
 * Зневадження: window.WXM_WEIGHTED_DEBUG = true; location.reload();
 */
(function () {
  'use strict';

  var CFG = window.WXM_WEIGHTED || {};
  var API = (CFG.api || 'https://ne4et.net/api/weighted/public').replace(/\/$/, '');
  var LANG = ((document.documentElement.lang || 'pl').toLowerCase().indexOf('uk') === 0) ? 'uk' : 'pl';
  var FRESH_MS = 10000;      // повторна перевірка кошика не частіше, ніж раз на 10 с
  var CHECKOUT_FRESH_MS = 45000;

  var TEXTS = {
    pl: {
      reserved_until: 'Zarezerwowane dla Ciebie do {t}',
      renewed_until: 'Rezerwacja odnowiona — do {t}',
      checking: 'Sprawdzamy rezerwację…',
      choose_other: 'Wybierz inną wagę:',
      swap: 'Zamień',
      remove: 'Usuń',
      none_left: 'Ten produkt nie ma już wolnych kawałków — usuń go z koszyka.',
      fix_first: 'Popraw zaznaczone pozycje w koszyku, aby przejść do kasy.',
      offline: 'Nie udało się sprawdzić rezerwacji. Spróbuj ponownie za chwilę.',
      taken_chip: 'w koszyku innego klienta',
      mine_chip: 'już w Twoim koszyku',
      mine_full: 'Ten kawałek jest już w Twoim koszyku — innego o tej wadze nie ma.',
      chip_mine_note: '✓ w koszyku',
      chip_mine_more: '{n} w koszyku',
      chip_taken_note: 'zajęty',
      in_cart: 'W Twoim koszyku: {list} ({n} szt.). Poniżej wybierz kolejny kawałek.',
      all_in_cart: 'Wszystkie dostępne kawałki są już w Twoim koszyku',
      none_free: 'Brak wolnych kawałków',
      reserve_failed: 'Nie udało się zarezerwować kawałka. Spróbuj ponownie.',
      minutes: 'min',
    },
    uk: {
      reserved_until: 'Заброньовано для вас до {t}',
      renewed_until: 'Бронь поновлено — до {t}',
      checking: 'Перевіряємо бронь…',
      choose_other: 'Оберіть іншу вагу:',
      swap: 'Замінити',
      remove: 'Прибрати',
      none_left: 'Вільних шматків цього товару вже немає — прибери його з кошика.',
      fix_first: 'Виправ позначені позиції в кошику, щоб перейти до оплати.',
      offline: 'Не вдалося перевірити бронь. Спробуй ще раз за хвилину.',
      taken_chip: 'у кошику іншого клієнта',
      mine_chip: 'уже у твоєму кошику',
      mine_full: 'Цей шматок уже у твоєму кошику — іншого такої ваги немає.',
      chip_mine_note: '✓ у кошику',
      chip_mine_more: '{n} у кошику',
      chip_taken_note: 'зайнятий',
      in_cart: 'У твоєму кошику: {list} ({n} шт.). Нижче обери наступний шматок.',
      all_in_cart: 'Усі доступні шматки вже у твоєму кошику',
      none_free: 'Вільних шматків немає',
      reserve_failed: 'Не вдалося забронювати шматок. Спробуй ще раз.',
      minutes: 'хв',
    },
  };
  var T = TEXTS[LANG];

  var DBG = function () {
    if (window.WXM_WEIGHTED_DEBUG !== true) return;
    try { console.log.apply(console, ['[wxm-weighted]'].concat([].slice.call(arguments))); } catch (e) {}
  };

  // ── Допоміжне ─────────────────────────────────────────────────────────────

  function cartKey() {
    try {
      var k = localStorage.getItem('wxm_cart_key');
      if (!k) {
        k = 'ck-' + Math.random().toString(36).slice(2, 12) + Date.now().toString(36);
        localStorage.setItem('wxm_cart_key', k);
      }
      return k;
    } catch (e) {
      window.__wxmCartKey = window.__wxmCartKey || ('ck-mem-' + Math.random().toString(36).slice(2, 12));
      return window.__wxmCartKey;
    }
  }

  function api(method, path, body, timeoutMs) {
    var ctrl = typeof AbortController === 'function' ? new AbortController() : null;
    var timer = ctrl ? setTimeout(function () { ctrl.abort(); }, timeoutMs || 8000) : null;
    var init = { method: method, headers: { 'Content-Type': 'application/json' }, credentials: 'omit' };
    if (body) init.body = JSON.stringify(body);
    if (ctrl) init.signal = ctrl.signal;
    return fetch(API + path, init).then(function (r) {
      return r.text().then(function (txt) {
        var data = null;
        try { data = txt ? JSON.parse(txt) : null; } catch (e) {}
        if (!r.ok) {
          var err = new Error('api ' + r.status);
          err.status = r.status;
          err.data = data && data.detail ? data.detail : data;
          throw err;
        }
        return data;
      });
    }).finally(function () { if (timer) clearTimeout(timer); });
  }

  function cartFetch(url, payload) {
    // Рідні виклики кошика Shopify — через window.fetch навмисно: перехоплювач
    // wxm-kaucja-tandem.js бачить їх і доводить заставу/термобокс до ладу.
    return window.fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload),
    }).then(function (r) { return r.json(); });
  }

  function route(name, fallback) {
    return (window.routes && window.routes[name]) || fallback;
  }

  function fmtTime(iso) {
    if (!iso) return '';
    var d = new Date(String(iso).replace(' ', 'T'));
    if (isNaN(d.getTime())) return String(iso).slice(11, 16);
    return ('0' + d.getHours()).slice(-2) + ':' + ('0' + d.getMinutes()).slice(-2);
  }

  function money(v) {
    if (v == null) return '';
    var s = Number(v).toFixed(2).replace('.', ',');
    return s + ' zł';
  }

  function reasonOf(data) {
    if (!data) return null;
    return LANG === 'uk' ? (data.reason_uk || data.message) : (data.reason_pl || data.message);
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  // ⛔ У Dawn PUB_SUB_EVENTS оголошено через const — це НЕ властивість window,
  // перевіряти можна лише через typeof.
  function pubsubReady() {
    return typeof subscribe === 'function' && typeof publish === 'function' &&
      typeof PUB_SUB_EVENTS !== 'undefined' && !!PUB_SUB_EVENTS.cartUpdate;
  }

  function onCartUpdate(fn) {
    if (pubsubReady()) subscribe(PUB_SUB_EVENTS.cartUpdate, fn);
    document.addEventListener('cart:updated', fn);
    document.addEventListener('cart-update', fn);
  }

  function announceCartUpdate() {
    // Dawn перемальовує кошик і шухляду в CartItems.onCartUpdate(); викликаємо і через
    // pubsub, і напряму — щоб не залежати від порядку завантаження скриптів.
    var done = false;
    if (pubsubReady()) {
      try { publish(PUB_SUB_EVENTS.cartUpdate, { source: 'wxm-weighted' }); done = true; } catch (e) { DBG('publish failed', e); }
    }
    if (!done) {
      document.querySelectorAll('cart-items, cart-drawer-items').forEach(function (el) {
        if (typeof el.onCartUpdate === 'function') { try { el.onCartUpdate(); } catch (e) {} }
      });
    }
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { source: 'wxm-weighted' } }));
    cart.lastValidate = 0;
    scheduleValidate(true);
  }

  // ── 1. Картка товару ──────────────────────────────────────────────────────

  var stateCache = {}; // handle → {ts, data}

  function loadState(handle, force) {
    var c = stateCache[handle];
    if (!force && c && Date.now() - c.ts < 30000) return Promise.resolve(c.data);
    return api('GET', '/state?handle=' + encodeURIComponent(handle) + '&cart_key=' + encodeURIComponent(cartKey())).then(function (data) {
      stateCache[handle] = { ts: Date.now(), data: data };
      return data;
    });
  }

  function pickerOf(form) {
    var root = form.closest('product-info, .product__info-wrapper, quick-add-modal, section, body') || document;
    return root.querySelector('.wxm-weighted-picker');
  }

  function setChipNote(label, text) {
    var note = label.querySelector('.wxm-chip-note');
    if (!text) { if (note) note.remove(); return; }
    if (!note) {
      note = document.createElement('span');
      note.className = 'wxm-chip-note';
      label.appendChild(note);
    }
    note.textContent = text;
  }

  function applyState(form, data) {
    if (!data || data.mode !== 'exact') return;
    var picker = pickerOf(form);
    if (!picker) return;
    var byId = {};
    (data.variants || []).forEach(function (v) { byId[String(v.variant_id)] = v; });
    var inputs = picker.querySelectorAll('input[data-wxm-variant-id]');
    var needReselect = false, mine = [], mineCount = 0, enabledCount = 0;
    inputs.forEach(function (inp) {
      var v = byId[String(inp.dataset.wxmVariantId)];
      var label = picker.querySelector('label[for="' + inp.id + '"]');
      if (!label) return;
      label.classList.remove('wxm-chip--taken', 'wxm-chip--gone', 'wxm-chip--mine');
      label.removeAttribute('title');
      setChipNote(label, '');
      inp.disabled = false;
      if (!v) { enabledCount++; return; } // варіант невідомий серверу — лишаємо як є
      if (v.held_by_me > 0) {
        mine.push(v.weight_g + ' g' + (v.held_by_me > 1 ? ' ×' + v.held_by_me : ''));
        mineCount += v.held_by_me;
      }
      if (v.free <= 0) {
        inp.disabled = true;
        if (v.held_by_me > 0) {
          label.classList.add('wxm-chip--mine');       // уже в моєму кошику, більше таких нема
          label.title = T.mine_chip;
          setChipNote(label, T.chip_mine_note);
        } else if (v.held_by_others > 0) {
          label.classList.add('wxm-chip--taken');
          label.title = T.taken_chip;
          setChipNote(label, T.chip_taken_note);
        } else {
          label.classList.add('wxm-chip--gone');
        }
        if (inp.checked) needReselect = true;
      } else {
        enabledCount++;
        if (v.held_by_me > 0) setChipNote(label, T.chip_mine_more.replace('{n}', v.held_by_me));
      }
    });
    var ttl = picker.querySelector('[data-wxm-ttl]');
    if (ttl && data.ttl_min) ttl.textContent = data.ttl_min;

    // Рядок «У твоєму кошику: …» — щоб було видно, що вже взято, і що плашка нижче — наступний шматок
    var incart = picker.querySelector('.wxm-weighted-incart');
    if (mine.length) {
      if (!incart) {
        incart = document.createElement('p');
        incart.className = 'wxm-weighted-incart';
        var sel = picker.querySelector('.wxm-weighted-selected, .wxm-weighted-empty');
        if (sel) picker.insertBefore(incart, sel); else picker.appendChild(incart);
      }
      incart.textContent = T.in_cart.replace('{list}', mine.join(', ')).replace('{n}', mineCount);
    } else if (incart) {
      incart.remove();
    }

    // Наступний вільний шматок обираємо самі
    if (needReselect) {
      var first = null;
      inputs.forEach(function (inp) { if (!first && !inp.disabled) first = inp; });
      if (first) {
        first.checked = true;
        first.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    // Вільних не лишилось — кнопка неактивна з поясненням, а не «Wyprzedane»
    var btn = form.querySelector('.product-form__submit');
    var span = btn && btn.querySelector('span');
    if (btn && span) {
      if (enabledCount === 0 && inputs.length) {
        if (!btn.dataset.wxmOrigText) btn.dataset.wxmOrigText = span.textContent;
        span.textContent = mine.length ? T.all_in_cart : T.none_free;
        btn.disabled = true;
        btn.dataset.wxmDisabled = '1';
      } else if (btn.dataset.wxmDisabled === '1') {
        span.textContent = btn.dataset.wxmOrigText || span.textContent;
        btn.disabled = false;
        delete btn.dataset.wxmDisabled;
      }
    }
  }

  function refreshProductForms(force) {
    document.querySelectorAll('product-form[data-wxm-exact]').forEach(function (pf) {
      var handle = pf.dataset.wxmHandle;
      if (!handle) return;
      loadState(handle, force).then(function (data) { applyState(pf, data); }).catch(function (e) {
        DBG('state failed', e);
      });
    });
  }

  function showFormError(pf, text) {
    var wrap = pf.querySelector('.product-form__error-message-wrapper');
    var msg = wrap && wrap.querySelector('.product-form__error-message');
    if (!wrap || !msg) { alert(text); return; }
    msg.textContent = text;
    wrap.removeAttribute('hidden');
    wrap.classList.add('wxm-form-error');
  }

  function hideFormError(pf) {
    var wrap = pf.querySelector('.product-form__error-message-wrapper');
    if (wrap && wrap.classList.contains('wxm-form-error')) {
      wrap.setAttribute('hidden', '');
      wrap.classList.remove('wxm-form-error');
    }
  }

  function setBusy(form, busy) {
    var btn = form.querySelector('[type="submit"]');
    if (!btn) return;
    btn.classList.toggle('loading', !!busy);
    var sp = btn.querySelector('.loading__spinner');
    if (sp) sp.classList.toggle('hidden', !busy);
  }

  function submitNative(form, btn) {
    if (typeof form.requestSubmit === 'function') form.requestSubmit(btn || undefined);
    else form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!(form instanceof HTMLFormElement)) return;
    var pf = form.closest('product-form[data-wxm-exact]');
    if (!pf) return;
    if (form.dataset.wxmPass === '1') { delete form.dataset.wxmPass; return; }

    e.preventDefault();
    e.stopPropagation();
    var idInput = form.querySelector('input[name="id"]');
    var variantId = idInput && idInput.value;
    var btn = form.querySelector('[type="submit"]');
    if (!variantId) return;
    hideFormError(pf);
    setBusy(form, true);

    api('POST', '/holds', { cart_key: cartKey(), variant_id: String(variantId), source: 'site' })
      .then(function (h) {
        // Кілограм зі складу («1kg», якір) бронювати нічого — відважать при збиранні.
        // Сервер відповідає {kind:'kg', hold_id:null}; додаємо як звичайний товар.
        if (!h || !h.hold_id) {
          setBusy(form, false);
          form.dataset.wxmPass = '1';
          submitNative(form, btn);
          DBG('kg line, no hold needed', h);
          return;
        }
        var hidden = form.querySelector('input[name="properties[_wxm_hold]"]');
        if (!hidden) {
          hidden = document.createElement('input');
          hidden.type = 'hidden';
          hidden.name = 'properties[_wxm_hold]';
          form.appendChild(hidden);
        }
        hidden.value = h.hold_id;
        setBusy(form, false);
        form.dataset.wxmPass = '1';
        submitNative(form, btn);
        DBG('hold ok', h);
      })
      .catch(function (err) {
        setBusy(form, false);
        if (err && (err.status === 409 || err.status === 404 || err.status === 429)) {
          var txt = reasonOf(err.data) || T.reserve_failed;
          if (err.data && err.data.held_by_me) txt = T.mine_full;
          showFormError(pf, txt);
          var handle = pf.dataset.wxmHandle;
          if (handle) loadState(handle, true).then(function (d) { applyState(pf, d); }).catch(function () {});
          return;
        }
        // Сервер броні недоступний — покупця не блокуємо: додаємо без броні,
        // перевірка кошика на сервері прикріпить її пізніше («attached»).
        DBG('hold service unavailable, adding without hold', err);
        form.dataset.wxmPass = '1';
        submitNative(form, btn);
      });
  }, true);

  // Після додавання — прибрати прихований номер броні, щоб наступний клік узяв новий.
  onCartUpdate(function () {
    document.querySelectorAll('product-form[data-wxm-exact] input[name="properties[_wxm_hold]"]').forEach(function (el) {
      el.parentNode && el.parentNode.removeChild(el);
    });
    refreshProductForms(true);
  });

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
    subscribe(PUB_SUB_EVENTS.variantChange, function () { setTimeout(function () { refreshProductForms(false); }, 50); });
  }

  // Модальне швидке додавання підвантажує форму пізніше — стежимо за появою.
  var formObserver = new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      var m = muts[i];
      for (var j = 0; j < m.addedNodes.length; j++) {
        var n = m.addedNodes[j];
        if (n.nodeType !== 1) continue;
        if ((n.matches && n.matches('product-form[data-wxm-exact], .wxm-weighted-picker')) ||
            (n.querySelector && n.querySelector('product-form[data-wxm-exact], .wxm-weighted-picker'))) {
          refreshProductForms(false);
          return;
        }
      }
    }
  });

  // ── 2. Кошик і шухляда ────────────────────────────────────────────────────

  // hadLines: у цьому перегляді кошика вже були вагові рядки. Коли вони зникають (покупець прибрав
  // позицію), робимо ще один виклик перевірки з порожнім списком — сервер знімає брони цього кошика,
  // інакше шматок висів би «зайнятим» до кінця строку броні.
  var cart = { lastValidate: 0, lastExtend: '', results: {}, invalid: false, busy: null, sig: '', attaching: {}, hadLines: false };

  function lineEls() { return document.querySelectorAll('[data-wxm-exact-line]'); }

  function collectLines() {
    var seen = {}, lines = [];
    lineEls().forEach(function (el) {
      var key = el.dataset.wxmKey;
      if (!key || seen[key]) return;
      seen[key] = 1;
      lines.push({ line_key: key, variant_id: String(el.dataset.wxmVariant || ''), hold_id: el.dataset.wxmHold || null, source: 'site' });
    });
    return lines;
  }

  function signature() {
    return collectLines().map(function (l) { return l.line_key + ':' + (l.hold_id || ''); }).join('|');
  }

  function setInvalid(flag) {
    cart.invalid = !!flag;
    document.documentElement.classList.toggle('wxm-cart-invalid', cart.invalid);
  }

  function slotOf(el) { return el.querySelector('[data-wxm-slot]'); }

  function renderPending() {
    lineEls().forEach(function (el) {
      var slot = slotOf(el);
      if (slot && !slot.innerHTML.trim()) slot.innerHTML = '<span class="wxm-wl__wait">' + esc(T.checking) + '</span>';
    });
  }

  function renderOffline() {
    lineEls().forEach(function (el) {
      var slot = slotOf(el);
      if (slot) slot.innerHTML = '<span class="wxm-wl__wait">' + esc(T.offline) + '</span>';
      el.classList.remove('cart-item--wxm-invalid');
    });
  }

  function altsHtml(r) {
    var alts = r.alternatives || [];
    if (!alts.length) return '<span class="wxm-wl__none">' + esc(T.none_left) + '</span>';
    var opts = alts.map(function (a) {
      return '<option value="' + esc(a.variant_id) + '">' + esc(a.weight_g) + ' g — ' + esc(money(a.price)) + '</option>';
    }).join('');
    return '<div class="wxm-wl__alts"><label>' + esc(T.choose_other) + '</label>' +
      '<select class="wxm-wl__select">' + opts + '</select>' +
      '<button type="button" class="wxm-wl__swap button">' + esc(T.swap) + '</button></div>';
  }

  function render() {
    var anyInvalid = false;
    lineEls().forEach(function (el) {
      var r = cart.results[el.dataset.wxmKey];
      var slot = slotOf(el);
      if (!r || !slot) return;
      var bad = r.status === 'unavailable' || r.status === 'gone';
      el.classList.toggle('cart-item--wxm-invalid', bad);
      if (bad) {
        anyInvalid = true;
        slot.innerHTML = '<div class="wxm-wl__bad"><span class="wxm-wl__reason">' + esc(reasonOf(r) || '') + '</span>' +
          altsHtml(r) + '<button type="button" class="wxm-wl__remove link">' + esc(T.remove) + '</button></div>';
      } else {
        var tpl = r.status === 'renewed' ? T.renewed_until : T.reserved_until;
        slot.innerHTML = '<span class="wxm-wl__ok">' + esc(tpl.replace('{t}', fmtTime(r.expires_at))) + '</span>';
      }
    });
    setInvalid(anyInvalid);
  }

  function attachHolds(res) {
    // Рядок без номера броні (доданий старим шляхом) — сервер її створив, дописуємо
    // у властивість рядка, щоб замовлення несло номер. Один раз на рядок.
    (res.lines || []).forEach(function (l) {
      if (l.status !== 'attached' || !l.hold_id || cart.attaching[l.line_key]) return;
      cart.attaching[l.line_key] = 1;
      cartFetch(route('cart_change_url', '/cart/change.js'), { id: l.line_key, quantity: 1, properties: { _wxm_hold: l.hold_id } })
        .then(function () { announceCartUpdate(); })
        .catch(function (e) { DBG('attach failed', e); });
    });
  }

  function validate(extend) {
    var lines = collectLines();
    if (lines.length) {
      cart.hadLines = true;
    } else {
      setInvalid(false);
      if (!cart.hadLines) return Promise.resolve({ ok: true, lines: [] });
      cart.hadLines = false; // рядки прибрано — кажемо серверу зняти брони цього кошика
    }
    if (cart.busy) return cart.busy;
    if (lines.length) renderPending();
    cart.busy = api('POST', '/cart/validate', { cart_key: cartKey(), extend: extend || 'cart', lines: lines })
      .then(function (res) {
        cart.lastValidate = Date.now();
        cart.lastExtend = extend || 'cart';
        cart.results = {};
        (res.lines || []).forEach(function (l) { cart.results[l.line_key] = l; });
        cart.sig = signature();
        render();
        attachHolds(res);
        DBG('validate', res);
        return res;
      })
      .catch(function (err) {
        DBG('validate failed', err);
        renderOffline();
        setInvalid(false);
        return { ok: true, offline: true, lines: [] };
      })
      .finally(function () { cart.busy = null; });
    return cart.busy;
  }

  var scheduleTimer = null;
  function scheduleValidate(force) {
    clearTimeout(scheduleTimer);
    scheduleTimer = setTimeout(function () {
      if (!lineEls().length) {
        setInvalid(false);
        if (cart.hadLines) validate('cart'); // покупець прибрав останній ваговий рядок — зняти брони
        return;
      }
      var sig = signature();
      var fresh = Date.now() - cart.lastValidate < FRESH_MS;
      if (!force && fresh && sig === cart.sig) { render(); return; }
      validate('cart');
    }, 500);
  }

  // Клік по «Zamień» / «Usuń» у червоному рядку
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var el = t.closest('[data-wxm-exact-line]');
    if (!el) return;
    var swap = t.closest('.wxm-wl__swap');
    var remove = t.closest('.wxm-wl__remove');
    if (!swap && !remove) return;
    e.preventDefault();
    var key = el.dataset.wxmKey;
    el.classList.add('wxm-wl--busy');
    if (remove) {
      cartFetch(route('cart_change_url', '/cart/change.js'), { id: key, quantity: 0 })
        .then(function () { announceCartUpdate(); })
        .catch(function (err) { DBG('remove failed', err); el.classList.remove('wxm-wl--busy'); });
      return;
    }
    var select = el.querySelector('.wxm-wl__select');
    var newVariant = select && select.value;
    if (!newVariant) return;
    api('POST', '/holds', { cart_key: cartKey(), variant_id: String(newVariant), source: 'site' })
      .then(function (h) {
        return cartFetch(route('cart_change_url', '/cart/change.js'), { id: key, quantity: 0 }).then(function () {
          return cartFetch(route('cart_add_url', '/cart/add.js'), {
            items: [{ id: Number(newVariant), quantity: 1, properties: { _wxm_hold: h.hold_id } }],
          });
        });
      })
      .then(function () { cart.lastValidate = 0; announceCartUpdate(); })
      .catch(function (err) {
        DBG('swap failed', err);
        el.classList.remove('wxm-wl--busy');
        var slot = slotOf(el);
        if (slot && err && err.data) {
          var msg = slot.querySelector('.wxm-wl__reason');
          if (msg) msg.textContent = reasonOf(err.data) || T.reserve_failed;
        }
        cart.lastValidate = 0;
        scheduleValidate(true);
      });
  });

  // Страж кнопки «Оформити»: червоні рядки не пускають; перед оплатою — подовжити бронь.
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var btn = t.closest('[name="checkout"]');
    if (!btn) return;
    if (btn.dataset.wxmPass === '1') { delete btn.dataset.wxmPass; return; }
    if (!lineEls().length) return;
    if (window.wxmKaucjaBusy) return; // страж застави сам зупинить клік
    e.preventDefault();
    e.stopPropagation();
    if (cart.invalid) { flashInvalid(); return; }
    var fresh = cart.lastExtend === 'checkout' && Date.now() - cart.lastValidate < CHECKOUT_FRESH_MS;
    if (fresh) { pass(btn); return; }
    btn.classList.add('loading');
    validate('checkout').then(function (res) {
      btn.classList.remove('loading');
      if (res.ok) pass(btn); else flashInvalid();
    });
  }, true);

  function pass(btn) {
    btn.dataset.wxmPass = '1';
    btn.click();
  }

  function flashInvalid() {
    var first = document.querySelector('.cart-item--wxm-invalid');
    if (first) {
      first.scrollIntoView({ behavior: 'smooth', block: 'center' });
      first.classList.add('wxm-wl--flash');
      setTimeout(function () { first.classList.remove('wxm-wl--flash'); }, 1200);
    }
    var note = document.querySelector('.wxm-cart-note');
    if (note) { note.textContent = T.fix_first; note.hidden = false; setTimeout(function () { note.hidden = true; }, 4000); }
  }

  // Перемальовування кошика/шухляди (Dawn підміняє HTML цілими секціями)
  var cartObserver = new MutationObserver(function () { scheduleValidate(false); });
  function observeCart() {
    ['cart-items', 'cart-drawer-items', 'cart-drawer'].forEach(function (tag) {
      document.querySelectorAll(tag).forEach(function (el) {
        if (el.dataset.wxmObserved === '1') return;
        el.dataset.wxmObserved = '1';
        if (tag === 'cart-drawer') cartObserver.observe(el, { attributes: true, attributeFilter: ['class'] });
        else cartObserver.observe(el, { childList: true, subtree: true });
      });
    });
  }

  onCartUpdate(function () { scheduleValidate(true); });

  // ── Старт ─────────────────────────────────────────────────────────────────

  function init() {
    refreshProductForms(false);
    formObserver.observe(document.body, { childList: true, subtree: true });
    observeCart();
    if (lineEls().length) validate('cart');
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'visible') { cart.lastValidate = 0; scheduleValidate(true); refreshProductForms(true); }
    });
    DBG('ready', { api: API, lang: LANG, cartKey: cartKey() });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
